<template>
  <div class="o-search">
    <v-form :onSubmit="onSearch">
      <div slot="row">
        <div class="o-search__input">
          <v-input
            type="text"
            :placeholder="placeholder"
            :icon="true"
            :fluid="true"
            size="input"
            v-model="search"
            :clearButton="true"
            :buttonDisabled="search.length === 0">
            <icon name="search"></icon>
          </v-input>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
import { VInput } from '../atoms';
import VForm from './Form.vue';

export default {
  name: 'v-search',
  components: {
    VInput,
    VForm,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search',
    },
  },
  data() {
    return {
      search: '',
    };
  },
  created() {
    if (this.$route.query.q) {
      this.search = this.$route.query.q;
      this.onSearch();
    }
  },
  methods: {
    updateSearch() {
      this.$emit('input', this.search);
    },
    onSearch() {
      this.$router.replace({ query: { q: this.search } });
      this.$emit('onSearch', { value: this.search });
    },
  },
  watch: {
    search: {
      handler(value) {
        this.updateSearch();
        if (value.length === 0) {
          this.$router.replace({ query: {} });
          this.$emit('onResetSearch');
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.o-filter';

  #{$parent} {
    background: #fff;
    padding: $spacing-base;
    margin-bottom: $spacing-base;
    border: 1px solid $color-border;
    border-radius: 3px;
    position: relative;
    @include clearfix;
    &__input {
      // margin-bottom: $spacing-small;
      @include clearfix;
    }
    &__labels {
      margin-top: $spacing-small;
      @include clearfix;
    }
    &__button {
      position: absolute;
      right: $spacing-base;
      bottom: $spacing-base;
    }
  }
</style>
